import styled, { css } from 'styled-components';

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  ${({ theme, $lastRow }) => css`
    ${!$lastRow && css`
      border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    `};
  `};
`;

export const TableCell = styled.td`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 24px 0;
  `};
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: 24px;
`;

export const ToggleLabel = styled.label``;

export const LoadingContainer = styled.div`
  width: 24px;
`;

export const MobileListItem = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 0;
    position: relative;
  `};
`;

export const MobileListInfo = styled.span`
  ${({ theme, $actions }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    flex-direction: column;
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    line-height: ${theme.v2.font.lineHeight.text};
    width: fit-content;

    ${$actions && css`
      position: absolute;
      right: 0;
    `}
  `};
`;

export const InfoText = styled.p`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `};
`;
